import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getMyEntitlementsApiCall } from '@guryou/api-client-gql';
import { UserTypes } from '@guryou/core';
import { useCurrentUser } from '@guryou/redux';
import { OLD_UI_URL, routeProviderId, shouldSendToOldUi } from 'utils/uiVersion';

// Sends providers without the `ui.newVersion` entitlement to the old Deal UI (#1780).
// Fresh fetch per provider: the shared useEntitlements cache is per session, not per provider.
const UiVersionGuard = () => {
  const { pathname } = useLocation();
  const { user } = useCurrentUser();
  const providerId = routeProviderId(pathname);
  const isAdmin = user?.role === UserTypes.admin;
  const enabled = process.env.REACT_APP_UI_SWITCH === 'true';

  useEffect(() => {
    if (!enabled || isAdmin || !providerId || !user) return undefined;
    let active = true;
    getMyEntitlementsApiCall()
      .then(r => {
        const entitlements = r && r.success ? r.data : null;
        if (active && shouldSendToOldUi({ enabled, isAdmin, providerId, entitlements })) {
          window.location.replace(OLD_UI_URL);
        }
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [enabled, isAdmin, providerId, user]);

  return null;
};

export default UiVersionGuard;
